<div class="pyro">
  <div class="before"></div>
  <div class="after"></div>
</div>
<div class="w-100 h-100" (click)="closeDialog()"></div>